import axios from 'axios'


export const getAxios = () => axios.create({ baseURL: process.env.REACT_APP_API_HOST || 'http://localhost:3000' })
